export default __webpack_public_path__ + "static/media/blob-copy.e5953722.svg";